export var Microsoft365SelectionMode;
(function (Microsoft365SelectionMode) {
    Microsoft365SelectionMode["MICROSOFT_365_SELECTION_MODE_UNSPECIFIED"] = "MICROSOFT_365_SELECTION_MODE_UNSPECIFIED";
    Microsoft365SelectionMode["MICROSOFT_365_SELECTION_MODE_ALL"] = "MICROSOFT_365_SELECTION_MODE_ALL";
    Microsoft365SelectionMode["MICROSOFT_365_SELECTION_MODE_SPECIFIC"] = "MICROSOFT_365_SELECTION_MODE_SPECIFIC";
    Microsoft365SelectionMode["MICROSOFT_365_SELECTION_MODE_NONE"] = "MICROSOFT_365_SELECTION_MODE_NONE";
})(Microsoft365SelectionMode || (Microsoft365SelectionMode = {}));
